export const appVersion = import.meta.env.VITE_APP_VERSION?.trim() || 'development';
const revision = import.meta.env.VITE_BUILD_COMMIT?.trim() || 'local';

export const appBuildLabel = `v${appVersion} · ${revision.slice(0, 8)}`;
